module.exports = __webpack_public_path__ + "static/media/klauzura.b33e0890.jpg";